import React from 'react';
import { Link } from 'react-router-dom';

const Banner = ({ image, beforePage = "", currentPage = "" }) => {
    return (
        <div className="w-full relative pt-20">
            <div className="w-full h-48 md:h-60 overflow-hidden">
                <img className="w-full h-full object-cover" src={image} alt="Banner" />
            </div>

            {/* Breadcrumb - dipindah sedikit ke bawah agar tetap terlihat saat overlap */}
            {beforePage && currentPage && (
                <nav className="flex items-center gap-2 md:gap-3 text-sm md:text-base font-medium text-[#475467] px-4 md:px-24 pt-10 pb-12">
                    <Link to="/" className="hover:text-[#F36F21] transition-colors flex items-center">
                        <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                        </svg>
                    </Link>
                    <span className="text-gray-300">›</span>
                    <Link to="/v2/faq" className="hover:text-[#F36F21] transition-colors flex items-center">
                        <span className="transition-colors font-semibold">
                            FAQ
                        </span>
                    </Link>
                    <span className="text-gray-300">›</span>
                    <b className="text-gray-900 font-semibold">{currentPage}</b>
                </nav>
            )}
        </div>
    );
};

export default Banner;